import chain from '@/lib/axios-chain'
// 角色管理---项目角色
export const getRoleDatas = () => chain.create('/user/invite/getroles', 'get')
// 角色管理---开启关闭项目角色
export const changeRoleStatus = () =>
  chain.create('/user/invite/setroles', 'post')
// 角色管理---获取权限列表数据
export const getPermissionDatas = () =>
  chain.create('/user/permission/role-config', 'get')
// 角色管理---提交权限列表数据
export const updatePermissionDatas = () =>
  chain.create('/user/permission/role-update', 'post')
// 角色管理---新增角色名称
export const addRoleName = () => chain.create('/user/invite/addrole', 'post')
// 角色管理---删除角色
export const delRole = () => chain.create('/user/invite/delrole', 'post')
// 角色管理---编辑角色
export const editRole = () => chain.create('/user/invite/editrole', 'post')
